export const ABOUT_SEO = {
  title: 'About ToxicDetector | The Forensic AI Behind Gaslighting Detection',
  description:
    'Learn how ToxicDetector combines behavioral psychology, computational linguistics, and forensic AI to detect gaslighting, manipulation, emotional abuse, and toxic communication with evidence-based analysis.',
  keywords:
    'about ToxicDetector, forensic AI, gaslighting detection AI, AI relationship analysis, manipulation detection, emotional abuse detection, computational linguistics, behavioral psychology, conversation analysis AI, gaslighting analyzer, toxic relationship AI',
  canonical: 'https://toxicdetector.com/about',
  image:
    'https://cdn.magicpatterns.com/uploads/wonwX8zVL7YiLQwtTT8xq8/file_00000000e69c7243bed09cbc104eb039.png',
} as const

const FOUNDER = {
  '@type': 'Person',
  name: 'Chukwuka Paulgreen Agodi',
  jobTitle: 'Founder & Chief Architect',
  image: 'https://toxicdetector.com/images/chukwuka.jpg',
  url: 'https://toxicdetector.com/founder',
  worksFor: {
    '@type': 'Organization',
    name: 'ToxicDetector AI & Forensic Systems LTD',
  },
  sameAs: ['https://www.linkedin.com/in/chukwuka-paulgreen-b64334385/'],
}

export const ABOUT_SCHEMA = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'Organization',
      '@id': 'https://toxicdetector.com/#organization',
      name: 'ToxicDetector AI & Forensic Systems LTD',
      url: 'https://toxicdetector.com/',
      founder: {
        '@id': 'https://toxicdetector.com/founder#person',
      },
      sameAs: ['https://www.trustpilot.com/review/toxicdetector.com'],
    },
    {
      ...FOUNDER,
      '@id': 'https://toxicdetector.com/founder#person',
    },
    {
      '@type': ['AboutPage', 'WebPage'],
      '@id': 'https://toxicdetector.com/about#webpage',
      name: ABOUT_SEO.title,
      description: ABOUT_SEO.description,
      url: ABOUT_SEO.canonical,
      mainEntity: {
        '@id': 'https://toxicdetector.com/#organization',
      },
      about: {
        '@id': 'https://toxicdetector.com/#organization',
      },
      breadcrumb: {
        '@id': 'https://toxicdetector.com/about#breadcrumb',
      },
    },
    {
      '@type': 'BreadcrumbList',
      '@id': 'https://toxicdetector.com/about#breadcrumb',
      itemListElement: [
        {
          '@type': 'ListItem',
          position: 1,
          name: 'Home',
          item: 'https://toxicdetector.com/',
        },
        {
          '@type': 'ListItem',
          position: 2,
          name: 'About ToxicDetector',
          item: ABOUT_SEO.canonical,
        },
      ],
    },
  ],
}
